import React, {  Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, TopNav } from 'CommonComponent';


const DashboardLayout = () => {

  return (
    <>
      <div className='screen-area'>
        <TopNav />
        <div className='d-flex'>
          <Sidebar /> {/* Pass theme to SideBar */}
          <div className="content-area">
            <Suspense fallback={<div>Loading...</div>}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
